import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '..';
import VesselReportingInfo from './VesselReportingInfo';
import CreateVesselReport from './CreateVesselReport';
import { useDocumentTitle } from 'Components/useDocument.hooks';
import { EditReportProvider } from './EditCompletedReports/EditReportProvider';

const EditVesselReport = () => {
    const { VesselState } = useSelector((state: RootState) => state.Reporting);
    useDocumentTitle("Edit Vessel Report - ecoSAIL");

    return (
        <React.Fragment>
            <EditReportProvider
                editReportBool={false}
                activeEditTab={0}
                toggle={null}
                discardwarning={false}
                setActiveAddLfondsTab={null}
                setActiveAddEconTab={null}
                setActiveAddAryaTab={null}
            >
                {VesselState === 'EDIT' && <CreateVesselReport />}
                {VesselState === 'ONGOING_VESSEL_REPORTING' && (
                    <VesselReportingInfo />
                )}
            </EditReportProvider>
        </React.Fragment>
    )
}

export default EditVesselReport